module.exports = __webpack_public_path__ + "static/media/virtualSwitchLogo.a0478b47.png";